<template>
  <div class="maintenance-wrapper">
    
    <!-- 1. خلفية ذكية (نفس تيمة الموقع) -->
    <div class="background-overlay"></div>
    
    <!-- 2. المحتوى -->
    <div class="container d-flex align-items-center justify-content-center min-vh-100 position-relative z-index-1">
      <div class="maintenance-card text-center p-5 rounded-4 shadow-lg animate__animated animate__fadeInUp">
        
        <!-- الشعار -->
        <img src="/img/logo/edu.png" alt="Logo" class="logo-img mb-4 bg-white rounded-circle p-2 shadow-sm">

        <!-- أيقونة الصيانة المتحركة -->
        <div class="gears-container mb-4">
          <i class="fas fa-cog main-gear text-gold"></i>
          <i class="fas fa-cog small-gear text-light-blue"></i>
        </div>

        <h2 class="fw-bold text-primary-dark mb-3">النظام تحت الصيانة والتحديث</h2>
        
        <p class="text-muted fs-5 mb-4 lh-lg">
          نعتذر عن الإزعاج، نقوم حالياً بإجراء بعض التحسينات الهامة على منظومة الكنترول لضمان كفاءة وسرعة العمل.
          <br>
          <span class="text-gold fw-bold">سنعود للعمل خلال وقت قصير.</span>
        </p>

        <!-- شريط تحميل وهمي -->
        <div class="progress mb-4" style="height: 6px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar" style="width: 75%"></div>
        </div>

        <div class="d-flex justify-content-center gap-3">
            <a href="javascript:window.location.reload()" class="btn btn-primary px-4 fw-bold rounded-pill">
                <i class="fas fa-sync-alt ms-2"></i> تحديث الصفحة
            </a>
        </div>

        <!-- ============================================= -->
        <!-- قسم الوصول الخاص (للمطورين والأدمن فقط) -->
        <!-- ============================================= -->
        <div class="mt-5 pt-3 border-top position-relative">
            <small class="text-muted d-block mb-2">لجنة النظام والمراقبة - محافظة شمال سيناء</small>
            
            <!-- زر مخفي لإظهار حقل الإدخال -->
            <button 
                @click="showDevInput = !showDevInput" 
                class="btn btn-link text-decoration-none text-muted p-0 opacity-50" 
                title="وصول المطورين"
            >
                <i class="fas fa-key small"></i>
            </button>

            <!-- حقل إدخال المفتاح السري -->
            <div v-if="showDevInput" class="mt-3 d-flex justify-content-center gap-2 animate__animated animate__fadeIn">
                <input 
                    v-model="secretKey" 
                    @keyup.enter="bypassMaintenance"
                    type="password" 
                    class="form-control form-control-sm text-center border-primary w-50" 
                    placeholder="Secret Key..."
                >
                <button @click="bypassMaintenance" class="btn btn-sm btn-gold fw-bold">
                    دخول
                </button>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage',
  data() {
      return {
          showDevInput: false,
          secretKey: '',
          // ضع رابط الباك إند الرئيسي هنا (بدون /api)
          // مثال: http://localhost:8000 أو https://my-control-site.com
          backendBaseUrl: 'https://apicontrol.sinai-edu.com' 
       
          //  backendBaseUrl: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000'
      }
  },
  methods: {
      bypassMaintenance() {
          if(!this.secretKey) return;

          // توجيه المتصفح بالكامل لرابط الباك إند
          // لارافيل سيقوم بالتحقق من المفتاح، وضع الكوكيز، وإعادة التوجيه للموقع
          window.location.href = `${this.backendBaseUrl}/${this.secretKey}`;
      }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');

.maintenance-wrapper {
  font-family: 'Cairo', sans-serif;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #002147 0%, #0d47a1 100%);
  position: relative;
  overflow: hidden;
  direction: rtl;
}

/* زخرفة الخلفية */
.background-overlay {
    position: absolute;
    top: 0; left: 0; width: 100%; height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

/* الكارت الأبيض */
.maintenance-card {
    background: rgba(255, 255, 255, 0.95);
    border-top: 5px solid #ffc107;
    max-width: 600px;
    width: 90%;
    backdrop-filter: blur(10px);
}

.logo-img {
    width: 90px; height: 90px; object-fit: contain;
}

/* ألوان النصوص */
.text-primary-dark { color: #002147; }
.text-gold { color: #ffc107; }
.text-light-blue { color: #0d47a1; }
.btn-gold { background-color: #ffc107; color: #000; border: none; }
.btn-gold:hover { background-color: #e0a800; }

/* --- أنيميشن التروس --- */
.gears-container {
    position: relative;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.main-gear {
    font-size: 4rem;
    animation: spin 4s linear infinite;
}
.small-gear {
    font-size: 2.5rem;
    position: absolute;
    margin-right: -55px;
    margin-top: 35px;
    animation: spin-reverse 4s linear infinite;
}

@keyframes spin { 100% { transform: rotate(360deg); } }
@keyframes spin-reverse { 100% { transform: rotate(-360deg); } }

/* تحسين الزر */
.btn-primary {
    background-color: #0d47a1;
    border-color: #0d47a1;
    transition: all 0.3s;
}
.btn-primary:hover {
    background-color: #002147;
    transform: translateY(-2px);
}
</style>